import Vue from 'vue'
import * as types from './mutation-types'
import * as R from 'ramda'

export default {
  [types.SET_CURRENT_ELEMENT_PATH] (state, path) {
    Vue.set(state, 'currentElementPath', path)
  },
  [types.CREATE_CATEGORY] (state, id) {
    Vue.set(state.currentDraft.categories, id, {
      id,
      groups: [],
      title: '新類別',
      new: true,
      categoryOrder: Object.keys(state.currentDraft.categories).length
    })
  },
  [types.SET_CATEGORY_PROPERTIES] (state, { id, properties }) {
    Object.keys(properties).forEach(k => {
      Vue.set(state.currentDraft.categories[id], k, properties[k])
    })
  },
  [types.UPDATE_CATEGORIES] (state, categories) {
    Vue.set(state.currentDraft, 'categories', categories)
  },
  [types.DELETE_CATEGORY] (state, categoryId) {
    Vue.delete(state.currentDraft.categories, categoryId)
  },
  [types.CREATE_GROUP] (state, { categoryId, groupId }) {
    Vue.set(state.currentDraft.groups, groupId, {
      categoryId,
      id: groupId,
      items: [],
      title: '',
      groupOrder: Object.keys(state.currentDraft.categories[categoryId].groups).length
    })
    state.currentDraft.categories[categoryId].groups.push(groupId)
  },
  [types.SET_GROUP_PROPERTIES] (state, { groupId, properties }) {
    Object.keys(properties).forEach(k => {
      Vue.set(state.currentDraft.groups[groupId], k, properties[k])
    })
  },
  [types.DELETE_GROUP] (state, { categoryId, groupId }) {
    const groupIds = state.currentDraft.categories[categoryId].groups
    const index = groupIds.findIndex(i => i === groupId)
    if (index !== -1) {
      groupIds.splice(index, 1)
      Vue.delete(state.currentDraft.groups, groupId)
      Object.keys(state.currentDraft.groups).forEach((k, i) => {
        Vue.set(state.currentDraft.groups[k], 'groupOrder', i)
      })
    }
  },
  [types.CREATE_ITEM] (state, { id, groupId }) {
    state.currentDraft.groups[groupId].items.push(id)
    Vue.set(state.currentDraft.items, id, {
      id,
      abbreviation: '簡稱',
      menuDraftVariation: state.currentDraft.variation,
      description: null,
      coverImgUrl: null,
      price: 100,
      questions: [],
      specialRequests: true,
      title: '新餐點',
      new: true
    })
  },
  [types.SET_ITEM_PROPERTIES] (state, { itemId, properties }) {
    Vue.set(state.currentDraft.items, properties.id, Object.assign(R.clone(state.currentDraft.items[itemId]), properties)) // 每次更改的時候都要重新做一個新的，這樣才不會改到其他一樣的
  },
  [types.CREATE_QUESTION] (state, { parentType, parentId, id, title, type, alwaysDisplay, options = [] }) {
    const menuDraftVariation = state.currentDraft.variation
    Vue.set(state.currentDraft.questions, id, { id, type, title, alwaysDisplay, menuDraftVariation, questionConstraints: null, options, new: true })
  },
  [types.SET_QUESTION_PROPERTIES] (state, { questionId, properties }) {
    Vue.set(state.currentDraft.questions, properties.id, Object.assign(R.clone(state.currentDraft.questions[questionId]), properties))
  },
  [types.CREATE_OPTION] (state, { id, title, price }) {
    const menuDraftVariation = state.currentDraft.variation
    Vue.set(state.currentDraft.options, id, { id, title, price, menuDraftVariation, optionConstraints: null, questions: [], new: true })
  },
  [types.SET_OPTION_PROPERTIES] (state, { optionId, properties }) {
    Vue.set(state.currentDraft.options, properties.id, Object.assign(R.clone(state.currentDraft.options[optionId]), properties))
  },
  [types.SET_MENU_DRAFT_LIST] (state, menuDraftList) {
    Vue.set(state, 'menuDraftList', menuDraftList)
  },
  [types.SET_CREATE_DRAFT_STATE] (state, createDraftState) {
    Vue.set(state, 'createDraftState', createDraftState)
  },
  [types.SET_DELETE_DRAFT_STATE] (state, deleteDraftState) {
    Vue.set(state, 'deleteDraftState', deleteDraftState)
  },
  [types.SET_DRAFT_INFO] (state, { variation: oldVariation, info: { title, variation } }) {
    state.currentDraft.title = title
    state.currentDraft.variation = variation
    const index = state.menuDraftList.findIndex(d => d.variation === oldVariation)
    Vue.set(state.menuDraftList, index, Object.assign(state.menuDraftList[index], {
      title,
      variation
    }))
  },
  [types.SET_CURRENT_DRAFT] (state, currentDraft) {
    Vue.set(state, 'currentDraft', currentDraft)
  },
  [types.INCREASE_MODIFICATION_COUNT] (state) {
    state.modificationCount++
  },
  [types.RESET_MODIFICATION_COUNT] (state) {
    state.modificationCount = 0
  },
  [types.SET_GET_CURRENT_DRAFT_STATE] (state, getCurrentDraftState) {
    Vue.set(state, 'getCurrentDraftState', getCurrentDraftState)
  },
  [types.SET_UPDATE_CURRENT_DRAFT_STATE] (state, updateCurrentDraftState) {
    Vue.set(state, 'updateCurrentDraftState', updateCurrentDraftState)
  }
}
